/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {fieldObjectSectionStyle} from '../helpers/graphQLShortcuts'
import Paragraph from "./Paragraph";
import {fieldObjectSectionStyleCss} from '../helpers/createStyles';
import {filterHeadline, filterHTML} from "../helpers/filters";
import './GeneralContent.scss';

interface Data {
    paragraphById: {
        fieldTxtHeadline: string;
        fieldTxtSubTitle: string;
        fieldHtmlBody: string;
        fieldObjectSectionStyle: Array<{entity: Array}>;
        fieldObjectCtas: Array<{targetRevisionId: string}>;
    }
}

class GeneralContentQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphComponentGeneralContent {
          fieldTxtHeadline
          fieldTxtSubTitle
          fieldObjectCtas {
            targetRevisionId
          }
          fieldHtmlBody {
            value
            format
            processed
          }
          fieldObjectSectionStyle {
              ${fieldObjectSectionStyle}
          }
        }
      }
    }
  }
}
`;

const GeneralContent = ({id, markComponentLoadedAs, handleLoadedComponents}) => (
    <GeneralContentQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            const styles = fieldObjectSectionStyleCss(field.fieldObjectSectionStyle);

            if (!styles.css.padding) {
                styles.css.padding = '80px 20px';
            }

            markComponentLoadedAs(id, true);

            return (
                <div className={`generalContent${styles.classNames}`} style={styles.css} id={styles.id}>
                    {styles.childBackground.isActive && (
                        <div className="generalContent__background" style={styles.childBackground.css}/>
                    )}
                    <div className="container">
                        {field.fieldTxtHeadline && (
                            <h2 dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtHeadline)}} />
                        )}

                        {field.fieldTxtSubTitle && (
                            <h3 dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtSubTitle)}} />
                        )}

                        {field.fieldHtmlBody && field.fieldHtmlBody.processed && (
                            <div className="generalContent__body">
                                {filterHTML(field.fieldHtmlBody.processed, true)}
                            </div>
                        )}

                        {field.fieldObjectCtas && (
                            <div className="generalContent__ctas">
                                {field.fieldObjectCtas.map(component => (
                                    <Paragraph key={`${id}_${component.targetRevisionId}`}
                                               id={String(component.targetRevisionId)}
                                               handleLoadedComponents={handleLoadedComponents}/>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            );
        }}
    </GeneralContentQuery>
);

GeneralContent.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    handleLoadedComponents: PropTypes.func.isRequired
};

export default GeneralContent;



// WEBPACK FOOTER //
// ./frontend/components/GeneralContent.jsx